import { render, staticRenderFns } from "./addsklGardenAd.vue?vue&type=template&id=384e0bb8&"
import script from "./addsklGardenAd.vue?vue&type=script&lang=js&"
export * from "./addsklGardenAd.vue?vue&type=script&lang=js&"
import style0 from "./addsklGardenAd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports